














import { defineComponent, nextTick, onMounted, PropType, ref } from '@vue/composition-api';
import AdCampaignItem from '@/bundles/Ad/models/AdCampaignItem';

// @ts-ignore
import { Carousel, Slide } from 'vue-carousel';
import { Nullable } from '@/bundles/App/type';

export default defineComponent({
  components: {
    Carousel,
    Slide,
  },

  props: {
    mediaEntry: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },

  setup: function () {
    const key = ref<Nullable<Symbol>>(null);
    onMounted(() => {
      nextTick(() => {
        key.value = Symbol();
      });
    });

    return {
      key,
    };
  },
});
